module.exports = __webpack_public_path__ + "media/images/error_x_mark-aa37acda.svg";